import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses an httpOnly cookie set by the backend; no tokens touch JS-accessible storage.
const api = axios.create({ baseURL: API, withCredentials: true });

export function apiErr(e, fallback = "Something went wrong.") {
  const status = e?.response?.status;
  const d = e?.response?.data?.detail;
  if (!e?.response || [502, 503, 504].includes(status))
    return "The server is restarting (not a password problem). Wait about 30 seconds and try again.";
  if (status === 429 && d == null)
    return "Too many attempts. For security, wait 15 minutes and try again.";
  if (d == null) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export default api;
